import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { map, take } from 'rxjs/operators';

import { FeedAdvice } from '../models/feed-advice.models';
import { FeedAdviceService } from '../services/feed-advice.service';

@Injectable()
export class GetFeedAdviceByIdResolver {
  private feedAdviceService = inject(FeedAdviceService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  resolve(route: ActivatedRouteSnapshot) {
    return this.feedAdviceService.getFeedAdviceById(Number(route.paramMap.get('id'))).pipe(
      take(1),
      map((feedadvice: FeedAdvice) => feedadvice),
    );
  }
}
